import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db8f9182"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-gray-500 mb-4 mt-3"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-2 text-sm text-red-600"
}

import { Component, computed, ref, watch } from "vue"
import flatPickr from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import { formatters } from "@/shared/utils/dateUtils"

interface Props {
    position?: string
    modelValue: string | Date | undefined
    showTime?: boolean
    showDate?: boolean
    description?: string
    label?: string
    id?: string
    disabled?: boolean
    inline?: boolean
    minDate?: string
    required?: boolean
    errorMessage?: string
    invalid?: boolean
    iconStart?: Component
    isForm?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsCalendar',
  props: {
    position: {},
    modelValue: {},
    showTime: { type: Boolean },
    showDate: { type: Boolean },
    description: {},
    label: {},
    id: {},
    disabled: { type: Boolean },
    inline: { type: Boolean, default: false },
    minDate: {},
    required: { type: Boolean },
    errorMessage: {},
    invalid: { type: Boolean },
    iconStart: {},
    isForm: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

let internalValue = ""
const flatpickrRef = ref(null)

const config = computed(() => ({
    position: props.position,
    enableTime: props.showTime,
    noCalendar: !props.showDate,
    minDate: props.minDate === "now" ? new Date() : props.minDate,
    dateFormat: props.showDate && props.showTime ? "m/d/Y h:i K" : props.showDate ? "m/d/Y" : "h:i K",
    ...(!props.isForm && { allowInvalidPreload: true }),
}))

const inputValue = computed({
    get: () => {
        if (props.modelValue !== internalValue) {
            internalValue = String(props.modelValue ?? "")
            if (props.modelValue) {
                return formatters.formatDateToIso(props.modelValue).slice(0, -1)
            }
            return ""
        }
        return internalValue
    },
    set: (value: string | Date) => {
        internalValue = String(value)
        emit("update:modelValue", value)
    },
})

const localErrorMessage = ref(props.errorMessage)
const localInvalid = ref(props.invalid)

const inputStyle = computed(() => [
    localInvalid.value && !inputValue.value ? "pr-10 placeholder-red-300" : "placeholder-gray-400",
    props.disabled ? "text-gray-400" : "",
    "appearance-none block w-full pl-2 py-2 border-0 focus:outline-none text-base rounded-md",
])

const allInputStyle = computed(() => [
    localInvalid.value && !inputValue.value
        ? "border-red-300 focus-within:ring-red-500 focus-within:border-red-500"
        : "focus-within:ring-primary-color-500 focus-within:border-primary-color-500 border-gray-300",
    "relative flex w-full  border rounded-md shadow-sm focus-within:outline-none text-base focus-within:ring-1",
])

const iconStyle = computed(() => "p-2 w-10 border-0 bg-white rounded-md text-gray-400 cursor-pointer")

const starStyle = computed(() => [localInvalid.value ? "text-red-600" : "text-gray-700", "pl-1"])

function disableValidationError() {
    localErrorMessage.value = ""
    localInvalid.value = false
}

const focusInput = () => {
    if (flatpickrRef.value) {
        flatpickrRef.value.$el.focus()
    }
}

watch(
    () => props.errorMessage,
    (newVal) => {
        localErrorMessage.value = newVal
        localInvalid.value = props.invalid
    }
)

watch(
    () => props.invalid,
    () => {
        localInvalid.value = props.invalid
    }
)

watch(
    () => props.minDate,
    (newMinDate) => {
        if (flatpickrRef.value && flatpickrRef.value?.config) {
            flatpickrRef.value.config.minDate = newMinDate === "now" ? new Date() : newMinDate
        }
    },
    {
        immediate: false,
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.inline ? '' : 'flex-col', 'flex'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: _ctx.id,
        class: _normalizeClass([_ctx.disabled ? 'opacity-40' : '', 'block mb-1 text-sm font-medium text-gray-700'])
      }, _toDisplayString(_ctx.label), 11, _hoisted_2),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(starStyle.value)
          }, "*", 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(allInputStyle.value)
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconStart), {
        class: _normalizeClass(iconStyle.value),
        onClick: focusInput
      }, null, 8, ["class"])),
      _createVNode(_unref(flatPickr), {
        modelValue: inputValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        ref_key: "flatpickrRef",
        ref: flatpickrRef,
        config: config.value,
        id: _ctx.id,
        class: _normalizeClass(inputStyle.value),
        disabled: _ctx.disabled,
        onInput: disableValidationError
      }, null, 8, ["modelValue", "config", "id", "class", "disabled"])
    ], 2),
    (localErrorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(localErrorMessage.value), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})